export default "__VITE_ASSET__BlmQKnsv__"